/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Rose_LabelInputs */

const en_ui_weather_rose_label = /** @type {(inputs: Ui_Weather_Rose_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wind relative to your direction of travel`)
};

const de_ui_weather_rose_label = /** @type {(inputs: Ui_Weather_Rose_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wind relativ zu deiner Bewegungsrichtung`)
};

/**
* | output |
* | --- |
* | "Wind relative to your direction of travel" |
*
* @param {Ui_Weather_Rose_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_rose_label = /** @type {((inputs?: Ui_Weather_Rose_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Rose_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_rose_label(inputs)
	return de_ui_weather_rose_label(inputs)
});